module.exports = __webpack_public_path__ + "static/img/ca_logo.4b4f18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ca_logo.png
// module id = LO9A
// module chunks = 1